/* eslint-disable no-underscore-dangle */
import { logError } from 'commons/logger';

const handleProductClick = (algoliaMetaData = {}) => {
  const objectID = algoliaMetaData?.objectID;
  const queryID = algoliaMetaData?.queryID;

  const hasSearchContext =
    typeof objectID === 'string' &&
    objectID.length > 0 &&
    typeof queryID === 'string' &&
    queryID.length > 0;

  if (!hasSearchContext) {
    return;
  }

  if (window.aa && window.algoliaInitialized) {
    window.aa('clickedObjectIDsAfterSearch', {
      eventName: 'Product Clicked',
      userToken: window?.rudderanalytics?.getAnonymousId?.() || '',
      index: 'products_jb4',
      objectIDs: [algoliaMetaData?.objectID ?? ''],
      positions: [algoliaMetaData?.position ?? 0],
      queryID: algoliaMetaData?.queryID ?? '',
    });
  } else {
    logError('Algolia Insights not initialized yet.');
  }
};

export default handleProductClick;
